import _construct from "/app/node_modules/@babel/runtime/helpers/esm/construct.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.error.cause.js";
// Copyright 2017-2022 @polkadot/types-create authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Option } from '@polkadot/types-codec';
import { assert, isHex, isU8a, u8aEq, u8aToHex, u8aToU8a } from '@polkadot/util';
import { createClassUnsafe } from "./class.js"; // With isPedantic, actually check that the encoding matches that supplied. This
// is much slower, but verifies that we have the correct types defined

function checkInstance(created, matcher) {
  var u8a = created.toU8a();
  var rawType = created.toRawType();
  var isOk = // full match, all ok
  u8aEq(u8a, matcher) || // on a length-prefixed type, just check the actual length
  ['Bytes', 'Text', 'Type'].includes(rawType) && matcher.length === created.length || // when the created is empty and matcher is also empty, let it slide...
  created.isEmpty && matcher.every(function (v) {
    return !v;
  });
  assert(isOk, function () {
    return "".concat(rawType, ":: Decoded input doesn't match input, received ").concat(u8aToHex(matcher, 512), " (").concat(matcher.length, " bytes), created ").concat(u8aToHex(u8a, 512), " (").concat(u8a.length, " bytes)");
  });
}

function checkPedantic(created, _ref) {
  var _ref2 = _slicedToArray(_ref, 1),
      value = _ref2[0];

  if (isU8a(value)) {
    checkInstance(created, value);
  } else if (isHex(value)) {
    checkInstance(created, u8aToU8a(value));
  }
} // Initializes a type with a value. This also checks for fallbacks and in the cases
// where isPedantic is specified (storage decoding), also check the format/structure


function initType(registry, Type) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var _ref3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      blockHash = _ref3.blockHash,
      isOptional = _ref3.isOptional,
      isPedantic = _ref3.isPedantic;

  var created = _construct(isOptional ? Option.with(Type) : Type, [registry].concat(_toConsumableArray(params)));

  isPedantic && checkPedantic(created, params);

  if (blockHash) {
    created.createdAtHash = createTypeUnsafe(registry, 'Hash', [blockHash]);
  }

  return created;
} // An unsafe version of the `createType` below. It's unsafe because the `type`
// argument here can be any string, which, when it cannot parse, will yield a
// runtime error.


export function createTypeUnsafe(registry, type) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var Clazz = null;
  var firstError = null;

  try {
    Clazz = createClassUnsafe(registry, type);
    return initType(registry, Clazz, params, options);
  } catch (error) {
    firstError = new Error("createType(".concat(type, "):: ").concat(error.message));
  }

  if (Clazz && Clazz.__fallbackType) {
    try {
      Clazz = createClassUnsafe(registry, Clazz.__fallbackType);
      return initType(registry, Clazz, params, options);
    } catch (_unused) {// swallow, we will throw the first error again
    }
  }

  throw firstError;
}